/** @file Resolves once the open project's confirmed rev reaches a rev (or the project closes). */
import { docStore, type DocState } from '../../stores/docStore';
import { liveSession } from './liveSession';
import { noteOwnRev } from './noteOwnRev';

const reached = (state: DocState, rev: number): boolean => state.slice === null || state.slice.rev >= rev;

/** For callers that must see their own commit in `slice.confirmed` (the e2e dispatch hook, autorig, imports). A rev
 *  past the confirmed one is noted on the live session, so it is fetched even while the socket is closed. */
export function whenConfirmed(rev: number): Promise<void> {
  return new Promise((resolve) => {
    const state = docStore.getState();
    if (reached(state, rev)) {
      resolve();
      return;
    }
    const session = liveSession.get();
    if (session !== null && session.projectId === state.projectId) noteOwnRev(session, rev);
    const stop = docStore.subscribe((state) => {
      if (!reached(state, rev)) return;
      stop();
      resolve();
    });
  });
}
